import type { ReactNode } from 'react';
import { Outlet } from 'react-router';
import { Logo } from './Logo';
import { LanguageSwitch } from './LanguageSwitch';

export function AuthLayout() {
  return (
    <div className="flex min-h-full flex-col bg-bg">
      <header className="flex items-center justify-between px-6 py-5">
        <Logo />
        <LanguageSwitch />
      </header>
      <main className="flex flex-1 items-start justify-center px-5 pb-16 pt-4 md:items-center md:pt-0">
        <div className="w-full max-w-[420px]">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

export function AuthCard({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="rounded-2xl border border-line-subtle bg-surface p-7 shadow-panel">
      <h1 className="font-display text-[30px] font-semibold leading-tight text-ink">{title}</h1>
      {subtitle && <p className="mt-2 text-[14.5px] leading-relaxed text-ink-muted">{subtitle}</p>}
      <div className="mt-6">{children}</div>
      {footer && <div className="mt-6 border-t border-line-subtle pt-5 text-[13px]">{footer}</div>}
    </div>
  );
}
